isPreEvent